export default __webpack_public_path__ + "static/media/testslips.cc9d0fcc.jpg";